export const toTitleCase = (sentence) => {
    'use strict';
    const smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|v.?|vs.?|via)$/i;
    const alphanumericPattern = /([A-Za-z0-9\u00C0-\u00FF])/;
    const wordSeparators = /([ :–—-])/;
    if (!sentence)
        return '';
    return sentence
        .split(wordSeparators)
        .map((current, index, array) => {
        if (
        /* Check for small words */
        current.search(smallWords) > -1 &&
            /* Skip first and last word */
            index !== 0 &&
            index !== array.length - 1 &&
            /* Ignore title end and subtitle start */
            array[index - 3] !== ':' &&
            array[index + 1] !== ':' &&
            /* Ignore small words that start a hyphenated phrase */
            (array[index + 1] !== '-' || (array[index - 1] === '-' && array[index + 1] === '-'))) {
            return current.toLowerCase();
        }
        /* Ignore intentional capitalization */
        if (current.substr(1).search(/[A-Z]|\../) > -1) {
            return current;
        }
        /* Capitalize the first letter */
        return current.replace(alphanumericPattern, (match) => {
            return match.toUpperCase();
        });
    })
        .join('');
};
const titleCase = ([head = '', ...tail] = '') => `${head.toUpperCase()}${tail.join('')}`;
export const toTitleCaseBasic = (str = '') => (str || '').toLowerCase().split(' ').map(titleCase).join(' ');
//# sourceMappingURL=to-title-case.js.map